import { useState } from 'react';
import './Features.css';

const features = [
  {
    id: 'tasks',
    icon: '📋',
    color: '#5B80F5',
    title: 'Tâches personnalisées',
    tagline: 'Co-construites avec l\'enfant',
    desc: 'Créez 4 à 5 missions en moins de 5 minutes. Titres, avatars, durées, récurrences — tout est personnalisable. L\'enfant choisit et s\'engage. Un mode "Bibliothèque" est disponible avec 30+ missions prédéfinies et préconfigurées (mot d\'Evo spécifiques)',
    video: '/images/04.mp4',
    highlights: [
      { icon: '⏱️', text: '20–60 sec par mission' },
      { icon: '🔁', text: 'Récurrence automatique' },
      { icon: '🎨', text: '100+ styles d\'avatars' },
      { icon: '👦', text: 'Multi-enfants' },
    ],
  },
  {
    id: 'xp',
    icon: '⚡',
    color: '#F59E0B',
    title: 'Système d\'XP et niveaux',
    tagline: 'La progression devient visible',
    desc: '5 types de missions, de Commune à Légendaire, avec des gains d\'XP adaptés. L\'enfant peut même auto-évaluer son effort — un vrai feedback sur son efficacité personnelle.',
    video: '/images/01.mp4',
    highlights: [
      { icon: '🏅', text: 'Commune : 100 XP' },
      { icon: '💜', text: 'Rare : 150 XP' },
      { icon: '🔥', text: 'Épique : 200 XP' },
      { icon: '🌟', text: 'Légendaire : 600 XP' },
    ],
  },
  {
    id: 'evo',
    icon: '💌',
    color: '#F84FA3',
    title: 'Le petit mot d\'Evo',
    tagline: 'Le lien parent-enfant renforcé',
    desc: 'Écrivez un message bienveillant qui apparaîtra quand votre enfant valide sa mission. Vous manquez d\'inspiration ? Choisissez parmi des phrases conçues par nos pédagogues. Le sourire est garanti.',
    video: '/images/02.mp4',
    highlights: [
      { icon: '💬', text: 'Message personnalisé' },
      { icon: '🎲', text: 'Messages aléatoires' },
      { icon: '📚', text: 'Conçu par des pédagogues' },
      { icon: '❤️', text: 'Renforce l\'estime de soi' },
    ],
  },
  {
    id: 'autonomy',
    icon: '🚀',
    color: '#34C78A',
    title: 'Mode Autonomie',
    tagline: 'De la motivation extrinsèque à intrinsèque',
    desc: 'Quand l\'enfant est prêt, activez progressivement ce mode. Les missions choisies ne donnent plus d\'XP mais un message d\'encouragement. L\'enfant apprend à agir pour lui-même.',
    video: '/images/03.mp4',
    highlights: [
      { icon: '⚙️', text: 'Intensité configurable' },
      { icon: '🎯', text: 'Tirage aléatoire' },
      { icon: '🌱', text: 'Motivation intrinsèque' },
      { icon: '📊', text: 'Progressif et doux' },
    ],
  },
];

export default function Features() {
  const [active, setActive] = useState('tasks');
  const feat = features.find(f => f.id === active);

  return (
    <section className="features" id="fonctionnalites">
      <div className="container">
        <div className="features__header">
          <div className="section-label">✨ Fonctionnalités</div>
          <h2 className="section-title">Tout ce dont vous avez besoin</h2>
          <p className="section-subtitle">
            Evolify a été pensé pour être simple à utiliser, mais riche en accompagnement pédagogique.
          </p>
        </div>

        {/* Pills de navigation */}
        <div className="features__tabs">
          {features.map(f => (
            <button
              key={f.id}
              className={`features__tab ${active === f.id ? 'features__tab--active' : ''}`}
              onClick={() => setActive(f.id)}
              style={active === f.id ? { '--tab-color': f.color } : {}}
            >
              <span className="features__tab-icon">{f.icon}</span>
              <span className="features__tab-label">{f.title}</span>
            </button>
          ))}
        </div>

        {/* Wrapper : card colorée + phone extérieur */}
        <div
          className="features__wrapper"
          key={active}
          style={{ '--panel-color': feat.color }}
        >
          {/* Card colorée — texte + highlights */}
          <div className="features__panel">
            <div className="features__panel-icon-wrap">
              <span className="features__panel-icon">{feat.icon}</span>
            </div>
            <span className="features__panel-chip">{feat.tagline}</span>
            <h3 className="features__panel-title">{feat.title}</h3>
            <p className="features__panel-desc">{feat.desc}</p>

            <div className="features__panel-highlights">
              {feat.highlights.map((h, i) => (
                <div key={i} className="features__panel-hl">
                  <span className="features__panel-hl-icon">{h.icon}</span>
                  <span className="features__panel-hl-text">{h.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Phone — en dehors de la card */}
          <div className="features__phone-col">
            <div className="features__phone-wrap">
              <div className="features__phone">
                <div className="features__phone-notch" />
                <video
                  key={feat.video}
                  className="features__phone-screen"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src={feat.video} type="video/mp4" />
                </video>
                <div className="features__phone-shine" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
